<template>
    <div class="vCenter read">
      <img src="/img/icon/read.png" alt="">
      <div>
        {{readcount}}
      </div>
    </div>
</template>
<script>
export default {
  name: "UmReadcount",
  data() {
    return {
      readcount: 0
    };
  },
  props: ["sid","appid"],
  mounted() {
    var that = this;
    that.umid=$UMCore.uncompile("umid")
    var waitReady = function() {
      if (that.appid != '' && that.appid != undefined) {
        that.readNews(); 
      } else {
        setTimeout(function() {
          waitReady();
        }, 20);
      }
    };
    setTimeout(function() {
      waitReady();
    }, 50);
    
  },
  methods: {
    readNews() {
        var that = this
        $UMCore.post("/route.lua", {
            data:JSON.stringify({
                functionname: 'extension_readcount',
                appid: that.appid,
                dappuuid: that.sid,
                readcount: 1
            })
        })
        .then(function(response) {
            if (response.data.status === true) {
                that.readcount = response.data.readcount
            } else {
                that.$message.error('网络错误！')
                return false
            }
        })
        .catch(function(error) {})
    },
  }
};
</script>
<style lang="scss" scoped>
.read {
  font-size: 12px;
  color: #999;
  > div {
    margin-left: 4px;
  }
}
</style>




// WEBPACK FOOTER //
// src/packages/readcount/um-readcount.vue